import { DoorHeightEnum } from 'CoreAPI/Components/DoorHeightEnum';
import { DoorWidthEnum } from 'CoreAPI/Components/DoorWidthEnum';
import { IMissingSkyttaProducts } from 'redux-store/products/products.store';

const MAX_TOLERANCES = 12; // +/- 6mm

const TOTAL_SKYTTA_HEIGHT_LOW_FRAME = 2045;
export const MIN_SKYTTA_HEIGHT_LOW_FRAME = TOTAL_SKYTTA_HEIGHT_LOW_FRAME - MAX_TOLERANCES / 2;
export const MAX_SKYTTA_HEIGHT_LOW_FRAME = TOTAL_SKYTTA_HEIGHT_LOW_FRAME + MAX_TOLERANCES / 2;

const TOTAL_SKYTTA_HEIGHT_HIGH_FRAME = 2397;
export const MIN_SKYTTA_HEIGHT_HIGH_FRAME = TOTAL_SKYTTA_HEIGHT_HIGH_FRAME - MAX_TOLERANCES / 2;
export const MAX_SKYTTA_HEIGHT_HIGH_FRAME = TOTAL_SKYTTA_HEIGHT_HIGH_FRAME + MAX_TOLERANCES / 2;

const ALL_DOOR_FRAMES = [
  [
    [
      '60497733', // SKYTTA slid door frm 102x196 aluminium
      '40497734', // SKYTTA slid door frm 102x196 black
      '10497735' // SKYTTA slid door frm 102x196 white
    ],
    [
      '90497736', // SKYTTA slid door frm 102x231 aluminium
      '70497737', // SKYTTA slid door frm 102x231 black
      '50497738' // SKYTTA slid door frm 102x231 white
    ]
  ],
  [
    [
      '00497726', // SKYTTA slid door frm 77x196 aluminium
      '80497727', // SKYTTA slid door frm 77x196 black
      '60497728' // SKYTTA slid door frm 77x196 white
    ],
    [
      '40497729', // SKYTTA slid door frm 77x231 aluminium
      '80497732', // SKYTTA slid door frm 77x231 black
      '00497731' // SKYTTA slid door frm 77x231 white
    ]
  ]
];

export enum DoorFrameColorEnum {
  Aluminium,
  Black,
  White
}

const DEFAULT_DOOR_FRAME_COLOR = DoorFrameColorEnum.Black;

export const getDoorFrameProductRef = (
  width: DoorWidthEnum,
  height: DoorHeightEnum,
  color: DoorFrameColorEnum
) => {
  return ALL_DOOR_FRAMES[width][height][color];
};

export const getDoorFrameProductReferences = (width: DoorWidthEnum, height: DoorHeightEnum) => {
  return ALL_DOOR_FRAMES[width][height];
};

export const getDoorFrameSize = (productRef: string) => {
  let widthType: DoorWidthEnum = 0;
  let heightType: DoorHeightEnum = 0;
  let colorType: DoorFrameColorEnum = 0;

  ALL_DOOR_FRAMES.forEach((width, widthIndex) => {
    width.forEach((height, heightIndex) => {
      height.forEach((art, colorIndex) => {
        if (art === productRef) {
          widthType = widthIndex;
          heightType = heightIndex;
          colorType = colorIndex;
        }
      });
    });
  });
  return {
    width: widthType,
    height: heightType,
    color: colorType
  };
};

export const isProductADoorFrame = (productRef: string) => {
  return ALL_DOOR_FRAMES.flat(2).some(id => {
    return id === productRef;
  });
};

export const isValidSkyttaColor = (
  missingSkyttaProducts: IMissingSkyttaProducts,
  doorHeightOptionsAvailable: DoorHeightEnum[],
  color: DoorFrameColorEnum
) => {
  const { railColors, lowDoorColors, highDoorColors } = missingSkyttaProducts;

  const missingColors = [...railColors];

  if (doorHeightOptionsAvailable.includes(DoorHeightEnum.Low)) {
    missingColors.push(...lowDoorColors);
  }

  if (doorHeightOptionsAvailable.includes(DoorHeightEnum.High)) {
    missingColors.push(...highDoorColors);
  }

  return !missingColors.includes(color);
};

export const getDefaultDoorFrameColorIndex = (
  missingSkyttaProducts: IMissingSkyttaProducts,
  doorHeightOptionsAvailable: DoorHeightEnum[]
) => {
  const isDefaultColorValid = isValidSkyttaColor(
    missingSkyttaProducts,
    doorHeightOptionsAvailable,
    DEFAULT_DOOR_FRAME_COLOR
  );

  if (isDefaultColorValid) {
    return DEFAULT_DOOR_FRAME_COLOR;
  }

  const fallback = Object.keys(DoorFrameColorEnum)
    .filter(v => {
      return !Number.isNaN(Number(v));
    })
    .find(value => {
      return isValidSkyttaColor(missingSkyttaProducts, doorHeightOptionsAvailable, +value);
    });

  return fallback ? +fallback : DEFAULT_DOOR_FRAME_COLOR;
};
